import {
  useTimetableSearch,
  type TimetableLineItem,
} from './useTimetableSearch';

export interface FindTimetableState {
  query: string;
  submittedQuery: string | null;
  setQuery: (value: string) => void;
  handleSubmit: (event: SubmitEvent) => boolean;
  submitError: string | null;
  hasSubmitted: boolean;
  loading: boolean;
  error: Error | null;
  lines: TimetableLineItem[];
}

/**
 * Models the "find a timetable" user task.
 *
 * This hook stays focused on timetable search and results selection.
 * Detailed timetable loading lives in `useTimetableDetails`.
 */
export function useFindTimetable(): FindTimetableState {
  const search = useTimetableSearch();

  return {
    query: search.query,
    submittedQuery: search.submittedQuery,
    setQuery: search.setQuery,
    handleSubmit: (event) => {
      event.preventDefault();
      return search.submitSearch();
    },
    submitError: search.submitError,
    hasSubmitted: search.hasSubmitted,
    loading: search.loading,
    error: search.error,
    lines: search.lines,
  };
}
